export default __webpack_public_path__ + "static/media/HDTX_The Invitation of GMS 24 Juni 2024.5403987b.pdf";